import React from "react";

const Footer = () => {
  return (
    <>
      <section id="contact" className="p-4 p-md-5 bg-dark text-white rounded-3">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
          <div>
            <h3 className="h4">Ready to get started?</h3>
            <p className="mb-0 text-white-50">
              Tell us about your project and we’ll propose a pragmatic plan and
              estimate.
            </p>
            <p style={{ marginTop: "50px" }}>
              © {new Date().getFullYear()} Casual Tech
            </p>
          </div>
          <div className="mt-3 mt-md-0">
            <div>
              <a
                href="mailto:info@casualtech.cloud"
                className="btn btn-light btn-lg"
                target="_blank"
              >
                Send a Mail Us
              </a>
            </div>

            <section className="mb-4" style={{ marginTop: "50px" }}>
              <a className="me-3 text-white" href="#return-policy">
                Return Policy
              </a>
              <a className="me-3 text-white" href="#refund-policy">
                Refund Policy
              </a>
              <a className="me-3 text-white" href="#privacy-policy">
                Privacy Policy
              </a>
              <a className="me-3 text-white" href="#disclaimer">
                Disclaimer
              </a>
              <a className="me-3 text-white" href="#tnc">
                Term & Conditions
              </a>
              <a className="me-3 text-white" href="#contact">
                Contact Us
              </a>
            </section>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
